import { zAny, zArr, zNum, zObj, zStr } from "./zodWrapper.js";
export const FreightLetterGetArgs = zObj({ plantId: zNum() });
export const FreightLetterPdf = zObj({
    fileId: zNum(),
    timestamp: zStr(),
});
export const FreightLetter = zObj({
    id: zNum(),
    data: zAny(),
    author: zStr(),
    timestamp: zStr(),
    pdfs: zArr(FreightLetterPdf),
});
export const FreightLetters = zArr(FreightLetter);
export const FreightLetterSaveNewArgs = zObj({
    plantId: zNum(),
    shipNo: zNum(),
    data: zAny(),
});
export const FreightLetterId = zNum();
export const FreightLetterSaveExistingArgs = zObj({
    id: zNum(),
    data: zAny(),
});
export const FreightLetterDeleteArgs = zObj({
    id: zNum(),
});
export const FreightLetterUploadPdfArgs = zObj({
    id: zNum(),
    data: zStr(),
});
export const FreightLetterGetPdfDataArgs = zObj({
    fileId: zNum(),
});
export const FreightLetterPdfData = zObj({
    data: zStr(),
});
export const FreightLetterDeletePdfArgs = zObj({
    fileId: zNum(),
});
//# sourceMappingURL=freightletter.js.map